import requestApi from 'utils/Request';
import {
  failureDownloadOrderExcel,
  failureDownloadOrderPDF,
  failureOrderList,
  failureOrderView,
  failureSyncDataOrder,
  requestDownloadOrderExcel,
  requestDownloadOrderPDF,
  requestOrderList,
  requestOrderView,
  requestSyncDataOrder,
  responseDownloadOrderExcel,
  responseDownloadOrderPDF,
  responseOrderList,
  responseOrderView,
  responseSyncDataOrder,
  requestCreditInvoiceDownload,
  responseCreditInvoiceDownload,
  failureCreditInvoiceDownload,
} from '../../slices/orderSlice/orderSlice';
import {
  ORDERLIST,
  SYNCDATAORDER,
  ORDER_INVOICE,
  DOWNLOAD_ORDER_EXCEL,
  ORDER,
} from 'utils/StaticApiEndpoints';
import Swal from 'sweetalert2';
import { CREDIT_INVOICE } from 'utils/StaticApiEndpoints';

////// List Order ////
export const ListOrderData = (payload) => async (dispatch) => {
  try {
    dispatch(requestOrderList());
    const res = await requestApi.get(ORDERLIST, { params: payload });
    dispatch(responseOrderList(res));
  } catch (error) {
    Swal.fire({
      icon: 'error',
      text: error?.message,
    });
    dispatch(failureOrderList(error?.message));
  }
};

//// Order Detail ////
export const ViewOrderDetailsData = (payload) => async (dispatch) => {
  try {
    dispatch(requestOrderView());
    const { data } = await requestApi.get(`${ORDER}/${payload?.id}`, payload);
    dispatch(responseOrderView(data));
  } catch (error) {
    Swal.fire({
      icon: 'error',
      text: error?.message,
    });
    dispatch(failureOrderView(error?.message));
  }
};

/////   Sync Order Data /////
export const SyncDataOrders = (callback) => async (dispatch) => {
  try {
    dispatch(requestSyncDataOrder());
    const response = await requestApi.get(`${SYNCDATAORDER}`);
    dispatch(responseSyncDataOrder(response));
    Swal.fire({
      icon: 'success',
      text: response.message,
    }).then(() => callback());
  } catch (error) {
    Swal.fire({
      icon: 'error',
      text: error?.message,
    });
    dispatch(failureSyncDataOrder(error?.message));
  }
};

//// Download excel Sheet data ///
export const getExcelOrderData = (payload) => async (dispatch) => {
  try {
    dispatch(requestDownloadOrderExcel());
    const response = await requestApi.get(DOWNLOAD_ORDER_EXCEL, {
      params: payload,
      responseType: 'blob',
    });

    const blob = new Blob([response], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');

    a.href = url;
    a.download = `Orders.xlsx`;

    a.click();
    window.URL.revokeObjectURL(url);

    dispatch(responseDownloadOrderExcel({ success: true }));
  } catch (error) {
    Swal.fire({
      icon: 'error',
      text: error?.message,
    });
    dispatch(failureDownloadOrderExcel(error?.message));
  }
};

////// Download PDF Invoice for Order //////

export const DownloadOrderPDF = (payload, callback) => async (dispatch) => {
  try {
    dispatch(requestDownloadOrderPDF());
    const response = await requestApi.get(`${ORDER_INVOICE}/${payload?.id}`, {
      responseType: 'blob',
    });
    const blob = new Blob([response], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');

    a.href = url;
    a.download = `Invoice-${payload?.id}.pdf`;

    a.click();
    window.URL.revokeObjectURL(url);
    dispatch(responseDownloadOrderPDF());
    if (typeof callback === 'function') {
      callback();
    }
  } catch (error) {
    Swal.fire({
      icon: 'error',
      text: error?.message,
    });
    dispatch(failureDownloadOrderPDF(error?.message));
  }
};

export const DownloadCreditInvoicePDF =
  (payload, callback) => async (dispatch) => {
    try {
      dispatch(requestCreditInvoiceDownload());

      const response = await requestApi.get(
        `${CREDIT_INVOICE}/${payload?.id}`,
        { responseType: 'blob' },
      );

      const blob = new Blob([response], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');

      a.href = url;
      a.download = `CR-${payload?.id}.pdf`;

      a.click();
      window.URL.revokeObjectURL(url);
      dispatch(responseCreditInvoiceDownload());
      if (typeof callback === 'function') {
        callback();
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        text: error?.message,
      });
      dispatch(failureCreditInvoiceDownload(error?.message));
    }
  };
